import { LOCATION } from 'bento-ordering/locations/constants/entities';
import { ACCOUNT } from 'bento-ordering/account/constants/entities';
import { CART } from 'bento-ordering/cart/constants/entities';

export const ROOT = `https://${
  window.location.hostname.split('.')[0]
}.localtest.me:8000`;

export const LINK_TO_BENTO_WEBSITE = '/';

export const BASE =
  process.env.NODE_ENV === 'production' ? '/api' : `${ROOT}/api`;

export const LOCATION_ENDPOINT = `${BASE}/online_ordering_location_public/`;
export const ACCOUNT_ENDPOINT = `${BASE}/online_ordering_account_public/`;
export const MENU_BASE = `${BASE}/online_ordering_menu_public/`;
export const VALIDATE_CART_ENDPOINT = `${BASE}/validate_cart/`;

export const MENU_ENDPOINT = `${MENU_BASE}`;
export const getMenuEndpoint = menuId => `${MENU_ENDPOINT}${menuId}/`;
const MENU_ITEMS_DETAIL_ENDPOINT = `${BASE}/online_ordering_menu_details/`;
export const getMenuDetailEndpoint = menuId =>
  `${MENU_ITEMS_DETAIL_ENDPOINT}${menuId}/`;
export const CART_ITEMS_AVAILABLE_ENDPOINT = `${BASE}/online_ordering_menu_public/menu/cart/available/`;

export const BASE_CART_ENDPOINT = '/store/cart';
export const CART_API_ENDPOINT = `${BASE_CART_ENDPOINT}/api`;
export const CART_JSON_ENDPOINT = `${BASE_CART_ENDPOINT}/json`;
export const BASE_CART_ITEM_ENDPOINT = '/store/cart_item';
export const SETUP_INITIAL_DATA_ENDPOINT = `${BASE}/online_ordering_initial_data/`;
export const VALIDATE_ADDRESS_ENDPOINT = `${BASE}/preview_delivery_address/`;
export const RELATE_LOCATIONS_TO_CART_ADDRESS_ENDPOINT = `${BASE}/relate_locations_to_cart_address/`;
export const DELIVERABLE_LOCATIONS_ENDPOINT = `${BASE}/get_deliverable_locations/`;

export const BASE_OO_CART_ENDPOINT = `/store/online_ordering_cart`;
export const OO_CART_API_ENDPOINT = `${BASE_OO_CART_ENDPOINT}/api`;
export const OO_CART_LOCATION_API_ENDPOINT = `${BASE}/set_cart_location`;
export const OO_CART_ADD_ENDPOINT = `${BASE_OO_CART_ENDPOINT}/add`;
export const BASE_LOCATION_INVENTORY_ENDPOINT = `${BASE}/location_inventory`;
export const BASE_LOCATION_THROTTLED_TIMES_ENDPOINT = `${BASE}/location_throttled_times`;
export const GOOGLE_MAPS_STATIC_URL_ENDPOINT =
  '/store/generate-google-maps-static-url';
export const getProductPricePreviewEndpoint = productId =>
  `${BASE_CART_ENDPOINT}/product/price_preview/${productId}`;

export const getUpdateCartItemEndpoint = cartItemId =>
  `${BASE_CART_ITEM_ENDPOINT}/${cartItemId}`;

export const getLocationInventoryEndpoint = locationId =>
  `${BASE_LOCATION_INVENTORY_ENDPOINT}/${locationId}/`;

export const getLocationThrottledTimesEndpoint = locationId =>
  `${BASE_LOCATION_THROTTLED_TIMES_ENDPOINT}/${locationId}/`;

// make these paths more restful
export const getMenuItemEndpoint = menuItemSlug =>
  `${BASE}/online_ordering_menu_public/menu/${menuItemSlug}/`;

export const getUpdatedLocationFulfillmentOptions = locationId =>
  `${BASE}/location_fulfillment_options/${locationId}`;

export const entityEndpointMap = {
  [LOCATION]: LOCATION_ENDPOINT,
  [ACCOUNT]: ACCOUNT_ENDPOINT,
  [CART]: BASE_CART_ENDPOINT
};
